import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { NotificationHandlerType } from '../../../../cinnamon-core/es/modules/notifications/constants.js';

var WebNotificationHandlerType = _objectSpread2(_objectSpread2({}, NotificationHandlerType), {}, {
  Reload: "reload",
  Redirect: "redirect"
});

export { WebNotificationHandlerType };
